import type { ExtraConfig } from '@gov-nx/core/app';
import { DataBoxFolderType } from '@gov-nx/module/data-box';
import { getPPKeyValues, MySubmissionTabs } from '@gov-nx/module/page';
import { ServiceCode } from '@gov-nx/module/service';

export const extraConfig = (environment: string): ExtraConfig => ({
	application: 'pp',
	environment,
	authorization: {
		enabled: false,
	},
	store: {
		persisKey: 'portal-podnikatele-zustand',
	},
	components: {
		isRezaSwitcherEnabled: false,
		databoxConnectModal: {
			isConsentCheckboxVisible: true,
		},
	},
	pageRoutes: {
		rezaDetailConfig: {
			rezaDetailContextProvider: {
				isSubjectCmsName: true,
				overrideCmsDescription: true,
				keyValues: getPPKeyValues,
			},
			rezaDetail: {
				isHeadlineTagVisible: false,
				isFavoriteToggleVisible: false,
				isHeadlineVisible: false,
				isRozsahVisible: false,
				isSeznamVisible: false,
				isActionsVisible: false,
				isComplaintVisible: false,
				isOverviewFormEnabled: false,
				isInvalidationVisible: false,
				isDownloadButtonVisible: false,
				isSendByDataBoxVisible: false,
			},
		},
		databoxConfig: {
			databoxTransformConfig: {
				deleteOdpojenoIfTrue: true,
			},
			massActionsAllowedFolders: [DataBoxFolderType.Trash],
			displayArchiveFolder: false,
			displayArchiveAction: false,
			displayBin: false,
			displayAutoArchiveToggle: false,
			displayNotificationPage: false,
			displayConnectedDataboxSettings: false,
			displayArchiveInEmptyFolderState: false,
			displayArchiveOptionsInInitialModal: false,
			displayArchiveTextOnDataboxDisconnect: false,
			displayPopupAfterDataboxConnected: false,
			isSaveToOwnDocumentsAllowed: false,
			isSelectAttachmentsFromOwnFilesRestrictedToPodani: true,
		},
		myFilesConfig: {
			showWithoutFile: false,
			isUploadAllowed: false,
			submitOnClear: true,
		},
		userManualConfig: {
			showMobileManual: false,
		},
		supportConfig: {
			shouldRenderPlaceholders: false,
		},
	},
	serviceRoutes: {
		serviceResolverConfig: {
			hiddenServices: [ServiceCode['smazani-uzivatelskeho-uctu']],
		},
	},
	settingsRoutes: {
		settingsPageConfig: {
			isNotificationsSettingsVisible: false,
			isContactHistoryEnabled: false,
			isNuDataEnabled: false,
		},
	},
	profileRoutes: {
		robConfig: {
			profileRobView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: false,
				},
			},
		},
		eDokladyConfig: {
			profileEDocumentsView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: false,
				},
			},
		},
		rosConfig: {
			profileRosView: {
				isDescriptionVisible: false,
				profileContentLayout: {
					isAccountDeletionLinkVisible: false,
				},
				PFOListView: {
					isDateOfTerminationVisible: true,
					isDateOfCreationVisible: false,
				},
			},
		},
		rosDetailConfig: {
			rosDetail: {
				isComplaintModalVisible: false,
				PODataView: {
					isComplaintCtaVisible: false,
				},
				PFODataView: {
					isComplaintCtaVisible: false,
				},
			},
		},
		certifikatyConfig: {
			profileCertificatesView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: false,
				},
			},
		},
		dokladyConfig: {
			documentsView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: false,
				},
			},
		},
		rezaProfileConfig: {
			profileRezaView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: false,
				},
			},
		},
	},
	submissionsRoutes: {
		routesConfig: {
			[MySubmissionTabs.podani]: {
				isAvailable: true,
			},
			[MySubmissionTabs.osvedceni]: {
				isAvailable: false,
			},
			[MySubmissionTabs.autorizace]: {
				isAvailable: false,
			},
		},
	},
	notificationRoutes: {
		notificationsConfig: {
			enabled: false,
		},
	},
	unauthorizedErrorCodes: [401],
});
